import { parseServerObjectToFormattedString } from '@innovyze/lib-am-common/Utils';
import { useTzDateTime } from '@innovyze/stylovyze';
import { ExpectedStringType } from '@Types';

export function useDateFormatter() {
	const formatDateUTC = useTzDateTime({ timeZone: 'UTC' }).formatDate;
	return (value: string | undefined) =>
		parseServerObjectToFormattedString(
			value,
			ExpectedStringType.Date,
			formatDateUTC,
		) || '-';
}
